<div class="nio-footer">
    <div class="nio-footer-links" *ngIf="!session?.isAdmin">
        <a class="nio-footer-link" (click)="navigateToProfileTab('CGU')" [translate]="'footer.mentionsLegales'"></a>
        <span class="nio-footer-separator">•</span>
        <a class="nio-footer-link" (click)="navigateToProfileTab('CGU')" [translate]="'footer.protectionDonnees'"></a>
        <span class="nio-footer-separator">•</span>
        <a class="nio-footer-link" (click)="navigateToProfileTab('ACCESSIBILITE')" [translate]="'footer.accessibilite'"></a>
    </div>

    <div class="nio-footer-copyright">
        <a class="nio-footer-cegid-link" href="https://www.cegid.com/" target="_blank" rel="noopener noreferrer"
           [translate]="'footer.copyright'" [translateParams]="{'currentYear': currentYear}"></a>
    </div>
</div>
